module.exports = __webpack_public_path__ + "img/footer-image.c7eeadce.png";